<template>
	<div class="zzgk_dialog">
		<el-dialog 
			:modal-append-to-body='true'
			width="1200px"
			center
			:append-to-body='true'
			@close="clearForm"
			:visible.sync="dialogFormVisible">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					组织架构
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData1">
				<img style="width: 100%;" src="@/assets/images/Organization.jpg" alt="">
			</div>
			
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { zzgk } from '@/axios'
	export default{
		data(){
			return{
				
			}
		},
		props:{
			dialogFormVisible:{
				type:Boolean,
				default:false
			}
		},
		mounted() {
			var that = this;
		},
		methods:{
		
			// 清除表单
			clearForm(){
				var that = this;
			
				that.$emit('closeEdit');
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	.zzgk_dialog{
		.el-dialog{
			z-index: 1000;
			width: 1200px;
		}
	}
	/deep/.el-dialog__body{
		padding: 0 20px;
	}
	
</style>
